<template>
  <div class="card mb-4">
    <div class="col-12">
      <transition name="slide-fade">
        <course-details
          v-if="isChildVisible"
          @close="hideChild"
          :course="course"
        />
      </transition>
      <transition name="slide-fade">
        <FormEditCourse
          v-if="isEditCourseVisible"
          @close="hideEditCourse"
          @close-edit-course="hideEditCourse"
          :course="course"
        />
      </transition>
    </div>
    <div class="card-header pb-0">
      <h6>{{ $t("courses.courses") }}</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("courses.title") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("teachers.activ") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("global.createdAt") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              ></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              ></th>
              <th class="text-secondary opacity-7 col-3"></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("teachers.details") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in courses" :key="item.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item.title }}</h6>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge
                  v-if="!item.deleted_at"
                  color="success"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.yes") }}
                </soft-badge>
                <soft-badge
                  v-else-if="item.deleted_at"
                  color="secondary"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.no") }}
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{
                  item.created_at
                }}</span>
              </td>
              <td class="align-middle text-center"></td>
              <td class="align-middle text-center"></td>
              <td class="align-middle text-center">
                <div v-if="lastSeason">
                  <div v-if="!item.deleted_at">
                    <a
                      class="btn btn-link text-dark px-3 mb-0"
                      href="javascript:;"
                      @click="editCourse(item)"
                    >
                      <i
                        class="fas fa-pencil-alt text-dark me-2"
                        aria-hidden="true"
                      ></i
                      >{{ $t("global.edit") }}
                    </a>
                    <a
                      class="btn btn-link text-danger text-gradient px-3 mb-0"
                      href="javascript:;"
                      @click="deleteCourse(item.id)"
                    >
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                      >{{ $t("global.delete") }}
                    </a>
                  </div>
                  <div v-else>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      class="me-3"
                      href="javascript:;"
                      @click="activateCourse(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'success' : 'secondary'"
                        class="custom-width"
                        variant="gradient"
                        size="sm"
                      >
                        {{ !item.valid ? $t("global.activate") : "" }}
                      </soft-badge>
                    </a>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      href="javascript:;"
                      @click="permanentlyDeleteCourse(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'danger' : 'secondary'"
                        class="custom-width"
                        variant="gradient"
                        size="lg"
                      >
                        {{ !item.valid ? $t("global.deleteForever") : "" }}
                      </soft-badge>
                    </a>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <a href="javascript:;" @click="showCourse(item)">
                  <soft-badge color="success" variant="gradient" size="sm">
                    {{ $t("teachers.details") }}
                  </soft-badge>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SoftBadge from "@/components/SoftBadge.vue";
import CourseDetails from "../components/CourseDetails";
import FormEditCourse from "@/components/FormEditCourse.vue";
import swal from "sweetalert2";

export default {
  name: "course-list",
  components: {
    SoftBadge,
    CourseDetails,
    FormEditCourse,
  },
  props: {
    courses: {
      type: Array,
      required: true,
      default: () => [],
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
    isEditFormVisible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      course: {},
      isChildVisible: false,
      isEditCourseVisible: false,
    };
  },
  watch: {
    isEditFormVisible(new_value) {
      this.isEditCourseVisible = new_value;
    },
  },
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },
  },
  methods: {
    editCourse(course) {
      this.course = course;
      this.isEditCourseVisible = true;
      this.$emit("close-create-form");
    },
    async deleteCourse(courseId) {
      const test = await axios.get("check-subcourses/" + courseId);
      let optionalText = "";
      test.data.subcourses.forEach(
        (item) => (optionalText += "<br>- " + item.title + ", ")
      );
      let text =
        optionalText != ""
          ? "Ovaj kurs sadrzi sledece podkurseve: " + optionalText
          : "";
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        html: text,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.delete("course/" + courseId);
          this.course = response.data.course;
          swal.fire({
            icon: "success",
            title: this.$t(response.data.message),
            showConfirmButton: true,
          });
          this.$emit("close-edit-course");
        } catch (error) {
          console.log(error);
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    showCourse(course) {
      this.course = course;
      this.isChildVisible = true;
      this.scrollToTop();
    },
    hideEditCourse() {
      this.isEditCourseVisible = false;
      this.$emit("close-edit-course");
    },
    hideChild() {
      this.isChildVisible = false;
    },
    async activateCourse(course) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.post("activate-course", {
            course: course.id,
          });
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-courses");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.close();
        swal.fire({
          title: this.$t("global.activationCancelled"),
          text: "",
          icon: "success",
        });
      }
      this.$emit("close-edit-course");
    },
    async permanentlyDeleteCourse(course) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: this.$t("courses.coursePermanentlyDelete"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.delete(
            "permanently-delete-course/" + course.id
          );
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-courses");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    },
  },
};
</script>
